module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/菌落计数仪-技术优势1.eff75516.png";